import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSOCOVID = '/acoesCovid'
const RECURSO = '/saude'
export default {
  buscarAbrigosporRegiao,
  buscarCasosObitos,
  buscarCasosObitosConsolidados,
  buscarCasosObitosAcumulado,
  buscarIsolamentoSocial,
  buscarAcoesPMSP,
  buscarDoacoesCidadeSolidaria,
}

function buscarAbrigosporRegiao ({ agrupamento }) {
  let params = { 'agrupamento': agrupamento }
  return Api.get(`${RECURSOCOVID}/buscarAbrigos${MetodosGlobais.createEncodeQuery(params)}`)
};

function buscarCasosObitos ({ inicio, fim }) {
  let params = { 'inicio': inicio, 'fim': fim }
  return Api.get(`${RECURSO}/covidCasosObitos${MetodosGlobais.createEncodeQuery(params)}`)
};

function buscarCasosObitosConsolidados ({ inicio, fim }) {
  let params = { 'inicio': inicio, 'fim': fim }
  return Api.get(`${RECURSO}/covidCasosObitosConsolidado${MetodosGlobais.createEncodeQuery(params)}`)
};

function buscarCasosObitosAcumulado ({ inicio, fim }) {
  let params = { 'inicio': inicio, 'fim': fim }
  return Api.get(`${RECURSO}/covidCasosObitosAcumulado${MetodosGlobais.createEncodeQuery(params)}`)
};

function buscarIsolamentoSocial ({ inicio, fim }) {
  let params = { 'inicio': inicio, 'fim': fim }
  return Api.get(`${RECURSO}/covidIsolamentoSocial${MetodosGlobais.createEncodeQuery(params)}`)
};

function buscarAcoesPMSP ({ inicio, fim }) {
  let params = { 'inicio': inicio, 'fim': fim }
  return Api.get(`${RECURSO}/covidAcoesPMSP${MetodosGlobais.createEncodeQuery(params)}`)
};

function buscarDoacoesCidadeSolidaria () {
  return Api.get(`licenciamentoUrbanismo/cidadeSolidaria/locaisDeEntregaBeneficiados`)
};